export const STATE_PROP = 'operators';

export const ELanguage = {
  ENGLISH: 'en',
  DEUTSCH: 'de',
  FRENCH: 'fr',
  SPANISH: 'es'
};

export const LANGUAGES = {
  [ELanguage.ENGLISH]: 'English',
  [ELanguage.DEUTSCH]: 'Deutsch',
  [ELanguage.FRENCH]: 'French',
  [ELanguage.SPANISH]: 'Spanish'
};
